import React from 'react';
import '../HomePage.css';
import { useAuth } from '../AuthContext';

const UserMentorSuggestions = () => {
    const { userData } = useAuth();

    return (
        <div className="mentor-suggestion-container">
            <h2 className="mentor-suggestion-heading">Welcome, {userData.name}!</h2>
            <p className="mentor-intro">
                Meeting with a career coach is an excellent opportunity to gain clarity, set goals, and create actionable plans for your professional growth. Here are some suggestions to help you make the most of your interaction.
            </p>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">1. Prepare Ahead of Time</h3>
                <p className="mentor-suggestion-text">
                    To maximize the value of your session, it’s important to come prepared. Here are some steps you can take:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Reflect on your current career goals and challenges you’re facing.</li>
                    <li>Prepare a list of questions you want to ask during the session.</li>
                    <li>Gather any relevant documents, such as your resume or portfolio, for review.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">2. Be Open to Feedback</h3>
                <p className="mentor-suggestion-text">
                    Constructive feedback can help you grow and refine your approach. Here’s how you can embrace it:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Listen actively and take notes on key suggestions.</li>
                    <li>Ask for clarification if any feedback feels unclear or challenging.</li>
                    <li>Focus on actionable steps to implement the feedback you receive.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">3. Discuss Your Goals and Aspirations</h3>
                <p className="mentor-suggestion-text">
                    A career coach can guide you better if they understand your vision. Share your thoughts openly:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Talk about your long-term and short-term career objectives.</li>
                    <li>Highlight areas where you feel stuck or need guidance.</li>
                    <li>Discuss potential career paths you are considering.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">4. Ask for Personalized Strategies</h3>
                <p className="mentor-suggestion-text">
                    Leverage your coach’s expertise to gain actionable insights tailored to your needs:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Seek advice on skill-building to stay competitive in your field.</li>
                    <li>Request guidance on creating a career roadmap or improving your resume.</li>
                    <li>Ask for tips on networking and expanding your professional connections.</li>
                </ul>
            </section>

            <section className="mentor-suggestion-section">
                <h3 className="mentor-suggestion-subheading">5. Follow Up After the Session</h3>
                <p className="mentor-suggestion-text">
                    Your meeting doesn’t end when the session is over. Ensure you take the next steps:
                </p>
                <ul className="mentor-suggestion-list">
                    <li>Review the notes you took during the session and prioritize action items.</li>
                    <li>Implement the strategies discussed and track your progress.</li>
                    <li>Consider scheduling a follow-up session to evaluate your growth.</li>
                </ul>
            </section>
        </div>
    );
};

export default UserMentorSuggestions;
